import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
  path: "/",
  redirect: "/dashboard",
},
{
  path: "/tidak-ditemukan",
  name: "404",
  component: () =>
    import( /* webpackChunkName: "404" */ "@/views/Error/404.vue"),
  meta: {
    title: "Halaman Tidak Ditemukan | Klik BOS",
    layout: "blank",
    rule: "isPublic",
  },
},
{
  path: "/dashboard",
  name: "Dashboard",
  component: () =>
    import( /* webpackChunkName: "dashboard" */ "@/views/Dashboard"),
  meta: {
    title: "Dasbor | Klik BOS",
    breadcrumbs: [{
      text: "Dashboard",
      disabled: true,
      to: "/",
    },],
    rule: "isLogged",
  },
},
{
  path: "/konseling",
  name: "Konseling",
  component: () =>
    import( /* webpackChunkName: "konseling" */ "@/views/Konseling/List.vue"),
  meta: {
    title: "Konseling | Klik BOS",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Konseling",
      to: "/konseling",
    },
    ],
    rule: "isLogged",
  },
},
{
  path: "/konseling/baru",
  name: "Konseling Baru",
  component: () =>
    import(
      /* webpackChunkName: "konseling-form" */
      "@/views/Konseling/Form.vue"
    ),
  meta: {
    title: "Konseling Baru | Klik BOS",
    back: "/konseling",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Konseling",
      to: "/konseling/baru",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isLogged",
  },
},
{
  path: "/konseling/:id",
  name: "Ubah Konseling",
  component: () =>
    import(
      /* webpackChunkName: "konseling-form" */
      "@/views/Konseling/Form.vue"
    ),
  meta: {
    title: "Ubah Konseling | Klik BOS",
    back: "/konseling",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Konseling",
      to: "/konseling",
    },
    {
      text: "Rincian",
    },
    ],
    rule: "isLogged",
  },
},
{
  path: "/kategori-konseling",
  name: "Kategori",
  component: () =>
    import(
      /* webpackChunkName: "kategori" */
      "@/views/Konseling/Kategori/List.vue"
    ),
  meta: {
    title: "Kategori | Klik BOS",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Kategori",
      to: "/kategori-konseling",
    },
    ],
    rule: "isSpitda",
  },
},
{
  path: "/kategori-konseling/baru",
  name: "Kategori Baru",
  component: () =>
    import(
      /* webpackChunkName: "kategori-form" */
      "@/views/Konseling/Kategori/Form.vue"
    ),
  meta: {
    title: "Kategori Baru | Klik BOS",
    back: "/kategori-konseling",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Kategori",
      to: "/kategori-konseling",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isSpitda",
  },
},
{
  path: "/kategori-konseling/:id",
  name: "Ubah Kategori",
  component: () =>
    import(
      /* webpackChunkName: "kategori-form" */
      "@/views/Konseling/Kategori/Form.vue"
    ),
  meta: {
    title: "Ubah Kategori | Klik BOS",
    back: "/kategori-konseling",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Kategori",
      to: "/kategori-konseling",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isSpitda",
  },
},
{
  path: "/label-konseling",
  name: "Label",
  component: () =>
    import(
      /* webpackChunkName: "label" */
      "@/views/Konseling/Label/List.vue"
    ),
  meta: {
    title: "Label | Klik BOS",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Label",
      to: "/label-konseling",
    },
    ],
    rule: "isSpitda",
  },
},
{
  path: "/label-konseling/baru",
  name: "Label Baru",
  component: () =>
    import(
      /* webpackChunkName: "label-form" */
      "@/views/Konseling/Label/Form.vue"
    ),
  meta: {
    title: "Label Baru | Klik BOS",
    back: "/label-konseling",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Label",
      to: "/label-konseling",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isSpitda",
  },
},
{
  path: "/label-konseling/:id",
  name: "Ubah Label",
  component: () =>
    import(
      /* webpackChunkName: "label-form" */
      "@/views/Konseling/Label/Form.vue"
    ),
  meta: {
    title: "Ubah Label | Klik BOS",
    back: "/label-konseling",
    breadcrumbs: [{
      text: "Konseling",
    },
    {
      text: "Label",
      to: "/label-konseling",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isSpitda",
  },
},
{
  path: "/bidang",
  name: "Bidang",
  component: () =>
    import( /* webpackChunkName: "bidang" */ "@/views/Master/Bidang/List.vue"),
  meta: {
    title: "Bidang | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Bidang",
      to: "/bidang",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/bidang/baru",
  name: "Bidang Baru",
  component: () =>
    import(
      /* webpackChunkName: "bidang-form" */
      "@/views/Master/Bidang/Form.vue"
    ),
  meta: {
    title: "Bidang Baru | Klik BOS",
    back: "/bidang",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Bidang",
      to: "/bidang",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/bidang/:id",
  name: "Bidang Ubah",
  component: () =>
    import(
      /* webpackChunkName: "bidang-form" */
      "@/views/Master/Bidang/Form.vue"
    ),
  meta: {
    title: "Ubah Bidang | Klik BOS",
    back: "/bidang",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Bidang",
      to: "/bidang",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pajak",
  name: "Pajak",
  component: () =>
    import( /* webpackChunkName: "pajak" */ "@/views/Master/Pajak/List.vue"),
  meta: {
    title: "Pajak | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Pajak",
      to: "/pajak",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pajak/baru",
  name: "Pajak Baru",
  component: () =>
    import(
      /* webpackChunkName: "pajak-form" */
      "@/views/Master/Pajak/Form.vue"
    ),
  meta: {
    title: "Pajak Baru | Klik BOS",
    back: "/pajak",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Pajak",
      to: "/pajak",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pajak/:id",
  name: "Pajak Ubah",
  component: () =>
    import(
      /* webpackChunkName: "pajak-form" */
      "@/views/Master/Pajak/Form.vue"
    ),
  meta: {
    title: "Ubah Pajak | Klik BOS",
    back: "/pajak",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Pajak",
      to: "/pajak",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/tahun",
  name: "Tahun",
  component: () =>
    import( /* webpackChunkName: "tahun" */ "@/views/Master/Tahun/List.vue"),
  meta: {
    title: "Tahun | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Tahun",
      to: "/tahun",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/tahun/baru",
  name: "Tahun Baru",
  component: () =>
    import(
      /* webpackChunkName: "tahun-form" */
      "@/views/Master/Tahun/Form.vue"
    ),
  meta: {
    title: "Tahun Baru | Klik BOS",
    back: "/tahun",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Tahun",
      to: "/tahun",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/tahun/:id",
  name: "Tahun Ubah",
  component: () =>
    import(
      /* webpackChunkName: "tahun-form" */
      "@/views/Master/Tahun/Form.vue"
    ),
  meta: {
    title: "Ubah Tahun | Klik BOS",
    back: "/tahun",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Tahun",
      to: "/tahun",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/status-anggaran",
  name: "Status Anggaran",
  component: () =>
    import(
      /* webpackChunkName: "status-anggaran" */
      "@/views/Master/StatusAnggaran/List.vue"
    ),
  meta: {
    title: "Status Anggaran | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Status Anggaran",
      to: "/status-anggaran",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/status-anggaran/baru",
  name: "Status Anggaran Baru",
  component: () =>
    import(
      /* webpackChunkName: "status-anggaran-form" */
      "@/views/Master/StatusAnggaran/Form.vue"
    ),
  meta: {
    title: "Status Anggaran Baru | Klik BOS",
    back: "/status-anggaran",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Status Anggaran",
      to: "/status-anggaran",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/status-anggaran/:id",
  name: "Status Anggaran Ubah",
  component: () =>
    import(
      /* webpackChunkName: "status-anggaran-form" */
      "@/views/Master/StatusAnggaran/Form.vue"
    ),
  meta: {
    title: "Ubah Status Anggaran | Klik BOS",
    back: "/status-anggaran",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Status Anggaran",
      to: "/status-anggaran",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/urusan",
  name: "Urusan",
  component: () =>
    import( /* webpackChunkName: "urusan" */ "@/views/Master/Urusan/List.vue"),
  meta: {
    title: "Urusan | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Urusan",
      to: "/urusan",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/urusan/baru",
  name: "Urusan Baru",
  component: () =>
    import(
      /* webpackChunkName: "urusan-form" */
      "@/views/Master/Urusan/Form.vue"
    ),
  meta: {
    title: "Urusan Baru | Klik BOS",
    back: "/urusan",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Urusan",
      to: "/urusan",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/urusan/:id",
  name: "Urusan Ubah",
  component: () =>
    import(
      /* webpackChunkName: "urusan-form" */
      "@/views/Master/Urusan/Form.vue"
    ),
  meta: {
    title: "Ubah Urusan | Klik BOS",
    back: "/urusan",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Urusan",
      to: "/urusan",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/program",
  name: "Program",
  component: () =>
    import(
      /* webpackChunkName: "program" */
      "@/views/Master/Program/List.vue"
    ),
  meta: {
    title: "Program | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Program",
      to: "/program",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/program/baru",
  name: "Program Baru",
  component: () =>
    import(
      /* webpackChunkName: "program-form" */
      "@/views/Master/Program/Form.vue"
    ),
  meta: {
    title: "Program Baru | Klik BOS",
    back: "/program",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Program",
      to: "/program",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/program/:id",
  name: "Program Ubah",
  component: () =>
    import(
      /* webpackChunkName: "program-form" */
      "@/views/Master/Program/Form.vue"
    ),
  meta: {
    title: "Ubah Program | Klik BOS",
    back: "/program",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Program",
      to: "/program",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/kegiatan",
  name: "Kegiatan",
  component: () =>
    import(
      /* webpackChunkName: "kegiatan" */
      "@/views/Master/Kegiatan/List.vue"
    ),
  meta: {
    title: "Kegiatan | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Kegiatan",
      to: "/kegiatan",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/Kegiatan/baru",
  name: "Kegiatan Baru",
  component: () =>
    import(
      /* webpackChunkName: "kegiatan-form" */
      "@/views/Master/Kegiatan/Form.vue"
    ),
  meta: {
    title: "Kegiatan Baru | Klik BOS",
    back: "/kegiatan",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Kegiatan Baru",
      to: "/kegiatan",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/kegiatan/:id",
  name: "Kegiatan Ubah",
  component: () =>
    import(
      /* webpackChunkName: "kegiatan-form" */
      "@/views/Master/Kegiatan/Form.vue"
    ),
  meta: {
    title: "Ubah Kegiatan | Klik BOS",
    back: "/kegiatan",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Kegiatan",
      to: "/kegiatan",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/sekolah",
  name: "Sekolah",
  component: () =>
    import(
      /* webpackChunkName: "sekolah" */
      "@/views/Master/Sekolah/List.vue"
    ),
  meta: {
    title: "Sekolah | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Sekolah",
      to: "/sekolah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/sekolah/baru",
  name: "Sekolah Baru",
  component: () =>
    import(
      /* webpackChunkName: "sekolah-form" */
      "@/views/Master/Sekolah/Form.vue"
    ),
  meta: {
    title: "Sekolah Baru | Klik BOS",
    back: "/sekolah",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Sekolah Baru",
      to: "/sekolah",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/sekolah/:id",
  name: "Sekolah Ubah",
  component: () =>
    import(
      /* webpackChunkName: "sekolah-form" */
      "@/views/Master/Sekolah/Form.vue"
    ),
  meta: {
    title: "Ubah Sekolah | Klik BOS",
    back: "/sekolah",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Sekolah",
      to: "/sekolah",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pejabat",
  name: "Pejabat",
  component: () =>
    import(
      /* webpackChunkName: "pejabat" */
      "@/views/Master/Pejabat/List.vue"
    ),
  meta: {
    title: "Pejabat | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Pejabat",
      to: "/pejabat",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pejabat/baru",
  name: "Pejabat Baru",
  component: () =>
    import(
      /* webpackChunkName: "bidang-form" */
      "@/views/Master/Pejabat/Form.vue"
    ),
  meta: {
    title: "Pejabat Baru | Klik BOS",
    back: "/pejabat",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Pejabat",
      to: "/pejabat",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pejabat/:id",
  name: "Pejabat Ubah",
  component: () =>
    import(
      /* webpackChunkName: "bidang-form" */
      "@/views/Master/Pejabat/Form.vue"
    ),
  meta: {
    title: "Ubah Pejabat | Klik BOS",
    back: "/pejabat",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Pejabat",
      to: "/pejabat",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/rekening",
  name: "Rekening",
  component: () =>
    import(
      /* webpackChunkName: "pejabat" */
      "@/views/Master/Rekening/List.vue"
    ),
  meta: {
    title: "Rekening | Klik BOS",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Rekening",
      to: "/rekening",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/rekening/rekening/baru",
  name: "Rekening Baru",
  component: () =>
    import(
      /* webpackChunkName: "bidang-form" */
      "@/views/Master/Rekening/Rekening/Form.vue"
    ),
  meta: {
    title: "Rekening Baru | Klik BOS",
    back: "/rekening",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Rekening Baru",
      to: "/rekening",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/rekening/rekening/:id",
  name: "Rekening Ubah",
  component: () =>
    import(
      /* webpackChunkName: "rekening-form" */
      "@/views/Master/Rekening/Rekening/Form.vue"
    ),
  meta: {
    title: "Ubah Rekening | Klik BOS",
    back: "/rekening",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Rekening",
      to: "/rekening",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/rekening/master/baru",
  name: "Master Rekening Baru",
  component: () =>
    import(
      /* webpackChunkName: "bidang-form" */
      "@/views/Master/Rekening/Master/Form.vue"
    ),
  meta: {
    title: "Master Rekening Baru | Klik BOS",
    back: "/rekening",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Rekening Master",
      to: "/rekening",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/rekening/master/:id",
  name: "Master Rekening Ubah",
  component: () =>
    import(
      /* webpackChunkName: "rekening-form" */
      "@/views/Master/Rekening/Master/Form.vue"
    ),
  meta: {
    title: "Ubah Master Rekening | Klik BOS",
    back: "/rekening",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Rekening Master",
      to: "/rekening",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},
// {
//   path: "/lokasi",
//   name: "Lokasi",
//   component: () =>
//     import(/* webpackChunkName: "sekolah" */ "@/views/Master/Lokasi/List.vue"),
//   meta: {
//     breadcrumbs: [
//       {
//         text: "Data Dasar",
//       },
//       {
//         text: "Lokasi",
//         to: "/lokasi",
//       },
//     ],
//   },
// },
{
  path: "/lokasi/baru",
  name: "Lokasi Baru",
  component: () =>
    import(
      /* webpackChunkName: "sekolah-form" */
      "@/views/Master/Lokasi/Form.vue"
    ),
  meta: {
    title: "Lokasi Baru | Klik BOS",
    back: "/lokasi",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Lokasi",
      to: "/lokasi",
    },
    {
      text: "Baru",
    },
    ],
  },
},
{
  path: "/lokasi/:id",
  name: "Lokasi Ubah",
  component: () =>
    import(
      /* webpackChunkName: "sekolah-form" */
      "@/views/Master/Lokasi/Form.vue"
    ),
  meta: {
    title: "Ubah Lokasi | Klik BOS",
    back: "/lokasi",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Lokasi",
      to: "/lokasi",
    },
    {
      text: "Ubah",
    },
    ],
  },
},
{
  path: "/laporan/rkas",
  name: "RKAS",
  component: () =>
    import( /* webpackChunkName: "rkas" */ "@/views/Laporan/RKAS/List.vue"),
  meta: {
    title: "RKAS | Klik BOS",
    selfPanel: true,
    breadcrumbs: [{
      text: "RKAS",
      disabled: true,
      to: "/rkas",
    },],
    rule: "isLogged",
  },
},
{
  path: "/laporan/rkas/baru",
  name: "RKAS Baru",
  component: () =>
    import(
      /* webpackChunkName: "rkas-form" */
      "@/views/Laporan/RKAS/Form.vue"
    ),
  meta: {
    title: "RKAS Baru | Klik BOS",
    back: "/laporan/rkas",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "RKAS",
      to: "/laporan/rkas",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isSwasta",
  },
},
{
  path: "/laporan/rkas/:id",
  name: "RKAS Ubah",
  component: () =>
    import(
      /* webpackChunkName: "rkas-form" */
      "@/views/Laporan/RKAS/Form.vue"
    ),
  meta: {
    title: "Ubah RKAS | Klik BOS",
    back: "/laporan/rkas",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "RKAS",
      to: "/laporan/rkas",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isSwasta",
  },
},
{
  path: "/laporan/realisasi",
  name: "Realisasi Dana Bos",
  component: () =>
    import(
      /* webpackChunkName: "rkas" */
      "@/views/Laporan/Realisasi/List.vue"
    ),
  meta: {
    title: "Realisasi Dana BOS | Klik BOS",
    selfPanel: true,
    breadcrumbs: [{
      text: "Realisasi Dana Bos",
      disabled: true,
      to: "/realisaidanabos",
    },],
    rule: "isLogged",
  },
},
{
  path: "/master/silpa",
  name: "Bosnas",
  component: () =>
    import(
      /* webpackChunkName: "rkas" */
      "@/views/Master/Silpa/List.vue"
    ),
  meta: {
    title: "Silpa",
    selfPanel: true,
    breadcrumbs: [{
      text: "Silpa",
      disabled: true,
      to: "/master/silpa",
    },],
    rule: "isLogged",
  },
},
{
  path: "/master/silpa/baru",
  name: "Silpa Baru",
  component: () =>
    import(
      /* webpackChunkName: "urusan-form" */
      "@/views/Master/Silpa/Form.vue"
    ),
  meta: {
    title: "Silpa Baru | Klik BOS",
    back: "/master/silpa",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "Silpa",
      to: "/silpa",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/laporan/bosnas",
  name: "Bosnas",
  component: () =>
    import(
      /* webpackChunkName: "rkas" */
      "@/views/Laporan/Bosnas/List.vue"
    ),
  meta: {
    title: "BOSNAS",
    selfPanel: true,
    breadcrumbs: [{
      text: "BOSNAS",
      disabled: true,
      to: "/laporan/bosnas",
    },],
    rule: "isLogged",
  },
},
{
  path: "/laporan/bosda",
  name: "Bosda",
  component: () =>
    import(
      /* webpackChunkName: "rkas" */
      "@/views/Laporan/Bosda/List.vue"
    ),
  meta: {
    title: "BOSDA",
    selfPanel: true,
    breadcrumbs: [{
      text: "BOSDA",
      disabled: true,
      to: "/laporan/bosda",
    },],
    rule: "isLogged",
  },
},
{
  path: "/laporan/sp2b",
  name: "SP2B",
  component: () =>
    import( /* webpackChunkName: "rkas" */ "@/views/Laporan/SP2B/List.vue"),
  meta: {
    title: "SP2B | Klik BOS",
    selfPanel: true,
    breadcrumbs: [{
      text: "SP2B",
      disabled: true,
      to: "/rkas",
    },],
    rule: "isLogged",
  },
},
{
  path: "/laporan/sp2b/baru",
  name: "SP2B Baru",
  component: () =>
    import(
      /* webpackChunkName: "rkas-form" */
      "@/views/Laporan/SP2B/Form.vue"
    ),
  meta: {
    title: "SP2B Baru | Klik BOS",
    back: "/laporan/sp2b",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "SP2B",
      to: "/laporan/sp2b",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isLogged",
  },
},
{
  path: "/laporan/sp2b/:id",
  name: "Ubah SP2B",
  component: () =>
    import(
      /* webpackChunkName: "rkas-form" */
      "@/views/Laporan/SP2B/Form.vue"
    ),
  meta: {
    title: "Ubah SP2B | Klik BOS",
    back: "/laporan/sp2b",
    breadcrumbs: [{
      text: "Data Dasar",
    },
    {
      text: "SP2B",
      to: "/laporan/sp2b",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isLogged",
  },
},
{
  path: "/transaksi",
  name: "Transaksi",
  component: () =>
    import(
      /* webpackChunkName: "rkas" */
      "@/views/Laporan/Transaksi/List.vue"
    ),
  meta: {
    title: "Transaksi | Klik BOS",
    breadcrumbs: [{
      text: "Laporan",
    },
    {
      text: "Transaksi",
      disabled: true,
      to: "/transaksi",
    },
    ],
    rule: "isLogged",
  },
},
{
  path: "/transaksi/baru",
  name: "Transaksi Baru",
  component: () =>
    import(
      /* webpackChunkName: "rkas" */
      "@/views/Laporan/Transaksi/Form.vue"
    ),
  meta: {
    title: "Transaksi Baru | Klik BOS",
    back: "/transaksi",
    breadcrumbs: [{
      text: "Laporan",
    },
    {
      text: "Transaksi",
      disabled: true,
      to: "/transaksi",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isSwasta",
  },
},
{
  path: "/transaksi/:id",
  name: "Transaksi Ubah",
  component: () =>
    import(
      /* webpackChunkName: "transaksi-form" */
      "@/views/Laporan/Transaksi/Form.vue"
    ),
  meta: {
    title: "Ubah Transaksi | Klik BOS",
    back: "/transaksi",
    breadcrumbs: [{
      text: "Laporan",
    },
    {
      text: "Transaksi",
      to: "/transaksi",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isSwasta",
  },
},
{
  path: "/company",
  name: "company-list",
  component: () =>
    import( /* webpackChunkName: "company-list" */ "@/views/Company/List.vue"),
  meta: {
    title: "Perusahaan | Klik BOS",
    breadcrumbs: [{
      text: "Company",
      disabled: true,
      to: "/company",
    },
    {
      text: "List",
      disabled: true,
      to: "/company",
    },
    ],
  },
},
{
  path: "/company/new",
  name: "company-new",
  component: () =>
    import( /* webpackChunkName: "company-new" */ "@/views/Company/Form.vue"),
  meta: {
    title: "Perusahaan Baru | Klik BOS",
    selfPanel: true,
    breadcrumbs: [{
      text: "Company",
      disabled: false,
      to: "/company",
    },
    {
      text: "New",
      disabled: true,
      to: "/company/new",
    },
    ],
  },
},

{
  path: "/pengaturan/pengguna",
  name: "Pengguna",
  component: () =>
    import(
      /* webpackChunkName: "pengguna" */
      "@/views/Pengaturan/Pengguna/List.vue"
    ),
  meta: {
    title: "Pengguna | Klik BOS",
    breadcrumbs: [{
      text: "Pengaturan",
    },
    {
      text: "Pengguna",
      to: "/pengaturan/pengguna",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pengaturan/pengguna/baru",
  name: "Pengguna Baru",
  component: () =>
    import(
      /* webpackChunkName: "pengguna-form" */
      "@/views/Pengaturan/Pengguna/Form.vue"
    ),
  meta: {
    title: "Pengguna Baru | Klik BOS",
    back: "/pengaturan/pengguna",
    breadcrumbs: [{
      text: "Pengaturan",
    },
    {
      text: "Pengguna",
      to: "/pengaturan/pengguna",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isAdmin",
  },
},
{
  path: "/pengaturan/pengguna/:id",
  name: "Ubah Pengguna",
  component: () =>
    import(
      /* webpackChunkName: "pengguna-form" */
      "@/views/Pengaturan/Pengguna/Form.vue"
    ),
  meta: {
    title: "Ubah Pengguna | Klik BOS",
    back: "/pengaturan/pengguna",
    breadcrumbs: [{
      text: "Pengaturan",
    },
    {
      text: "Pengguna",
      to: "/pengaturan/pengguna",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isAdmin",
  },
},

{
  path: "/pengaturan/grup",
  name: "Grup",
  component: () =>
    import( /* webpackChunkName: "grup" */ "@/views/Pengaturan/Grup/List.vue"),
  meta: {
    title: "Grup | Klik BOS",
    breadcrumbs: [{
      text: "Pengaturan",
    },
    {
      text: "Grup",
      to: "/pengaturan/grup",
    },
    ],
    rule: "isSuperAdmin",
  },
},
{
  path: "/pengaturan/grup/baru",
  name: "Grup Baru",
  component: () =>
    import(
      /* webpackChunkName: "grup-form" */
      "@/views/Pengaturan/Grup/Form.vue"
    ),
  meta: {
    title: "Grup Baru | Klik BOS",
    back: "/pengaturan/grup",
    breadcrumbs: [{
      text: "Pengaturan",
    },
    {
      text: "Grup",
      to: "/pengaturan/grup",
    },
    {
      text: "Baru",
    },
    ],
    rule: "isSuperAdmin",
  },
},
{
  path: "/pengaturan/grup/:id",
  name: "Ubah Grup",
  component: () =>
    import(
      /* webpackChunkName: "grup-form" */
      "@/views/Pengaturan/Grup/Form.vue"
    ),
  meta: {
    title: "Ubah Grup | Klik BOS",
    back: "/pengaturan/grup",
    breadcrumbs: [{
      text: "Pengaturan",
    },
    {
      text: "Grup",
      to: "/pengaturan/grup",
    },
    {
      text: "Ubah",
    },
    ],
    rule: "isSuperAdmin",
  },
},

{
  path: "/pengaturan/profil",
  name: "Profil",
  component: () =>
    import(
      /* webpackChunkName: "profil" */
      "@/views/Pengaturan/Profil/Form.vue"
    ),
  meta: {
    title: "Profil | Klik BOS",
    breadcrumbs: [{
      text: "Pengaturan",
    },
    {
      text: "Profil",
      to: "/pengaturan/profil",
    },
    ],
    rule: "isLogged",
  },
},

{
  path: "/login",
  name: "Login",
  meta: {
    title: "Login | Klik BOS",
    layout: "blank",
    rule: "isPublic",
  },
  component: () => import( /* webpackChunkName: "login" */ "@/views/Login"),
},

{
  path: "*",
  redirect: "/tidak-ditemukan"
},
];

const router = new VueRouter({
  routes,
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "Klik BOS";
  });
});

export default router;